import { RelationshipMapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { doRelationshipMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doRelationshipMappingUpdated';

export const removeRelationshipMapping =
  (relationshipMapping: RelationshipMapping) => (model: Model) => {
    model.removeLinkData(relationshipMapping);
    doRelationshipMappingUpdated(relationshipMapping)(model);
  };
